
import React, { createRef, useState } from 'react';
import { useScreenshot, createFileName } from 'use-react-screenshot'
import randomColor from 'randomcolor'
import { contrastColor } from 'contrast-color';
import { LightenDarkenColor } from 'lighten-darken-color'; 

import "@fontsource/inter/400.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/900.css";
import 'remixicon/fonts/remixicon.css'

import './App.css';
import Insult from './components/insults'
  
function shuffle(array) {
  var i = array.length,
      j = 0,
      temp;

  while (i--) {
      j = Math.floor(Math.random() * (i+1));
      temp = array[i];
      array[i] = array[j];
      array[j] = temp;
  }

  return array;
}

// Get all insults
let insults = shuffle(Insult)
// Now grab a random one when the page is loaded
let randomInsult = Math.floor(Math.random() * insults.length)

let color = randomColor()
let contrast = contrastColor({bgColor:color})

function App() {
  const ref = createRef(null)
  const [image, takeScreenshot] = useScreenshot({type: "image/jpeg", quality: 1.0})

  const download = (image, { name = "ithurts", extension = "jpg" } = {}) => {
    const a = document.createElement("a");
    a.href = image;
    a.download = createFileName(extension, name);
    a.click();
  };

  const getImage = () => takeScreenshot(ref.current).then(download)
  
  const [num, setNum] = useState(randomInsult);

  const handleClick = () => {
    color = randomColor()
    contrast = contrastColor({bgColor:color})
    if(num + 1 < insults.length){
      setNum(num + 1)
    }
    else{
      insults = shuffle(insults)
      setNum(0);
    }
  };

  return (
    <div ref={ref} className="App" style={{background:"linear-gradient(30deg, "+color+", "+ LightenDarkenColor(color,120)+")"}}>
      <header className="App-header">
        <div className='links'>
          <p className='title' style={{background:"linear-gradient(90deg, "+LightenDarkenColor(color, 50)+", "+ LightenDarkenColor(color, 30)+" 50%, "+ LightenDarkenColor(color, 40)+")", color:contrast}}>
            😖 Hurt a designer
          </p>
        </div>
        <h1 className="headline" style={{color:contrast}}>
          {insults[num]}
        </h1>
        <div className='buttons'>
          <button onClick={handleClick} style={{background:"linear-gradient(90deg, "+LightenDarkenColor(color, 50)+", "+ LightenDarkenColor(color, 30)+" 50%, "+ LightenDarkenColor(color, 40)+")", color:contrast}}>
              <i className="ri-refresh-line"></i>
              <span>Another</span>
          </button>
          <button onClick={getImage} title="Words that hurt any designer:" image={image} url="hurt.kotsky.me" className="share" style={{background:"linear-gradient(90deg, "+LightenDarkenColor(color, 50)+", "+ LightenDarkenColor(color, 30)+" 50%, "+ LightenDarkenColor(color, 40)+")", color:contrast}}>
              <i className="ri-screenshot-2-line"></i>
              <span>Screenshot</span>
          </button>
        </div>
        <p style={{color:contrast, marginBottom:"2rem"}} className='description'>
          Designed and built by <a rel="noreferrer" href="https://twitter.com/sirkotsky" target="_blank" style={{color:contrast}}>Kristian Mikhel</a>.
        </p>
      </header>
    </div>
  );
}

export default App;
